"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.leadsAPIRequestFactory = exports.fetchLeadsUrlResponse = exports.leadOtherSchema = exports.leadSourceSchema = exports.defaultParams = exports.methodPost = exports.headerJson = void 0;
const fluture_1 = require("fluture");
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const monet_1 = require("monet");
const yup_1 = require("yup");
const perimeterX_1 = __importDefault(require("../perimeterX"));
const errorLogging_1 = require("../thirdparty/errorLogging");
const fluture_utils_1 = require("../utils/fluture-utils");
exports.headerJson = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
};
exports.methodPost = { method: 'POST' };
exports.defaultParams = {
    ...exports.methodPost,
    headers: exports.headerJson,
};
exports.leadSourceSchema = (0, yup_1.string)()
    .optional();
exports.leadOtherSchema = (0, yup_1.string)()
    .optional();
const fetchLeadsUrlResponse = (url, fetchOptions) => (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(url, fetchOptions))
    .pipe(fluture_utils_1.verifyResponse)
    // parse conditionally since some leads endpoints return text instead of JSON
    .pipe((0, fluture_1.chain)(fluture_utils_1.safeAttemptBody))
    .pipe((0, fluture_1.map)(monet_1.Maybe.fromNull));
exports.fetchLeadsUrlResponse = fetchLeadsUrlResponse;
const leadsAPIRequestFactory = (url, fetchOptions, validation = Promise.resolve({})) => (handleFailure) => (handleSuccess) => (0, fluture_1.attemptP)(() => validation)
    .pipe((0, fluture_1.chainRej)(perimeterX_1.default))
    .pipe((0, fluture_1.chain)(() => (0, exports.fetchLeadsUrlResponse)(url, fetchOptions)))
    .pipe((0, fluture_1.fork)((e) => {
    (0, errorLogging_1.logError)(e);
    handleFailure && handleFailure(e);
})(handleSuccess));
exports.leadsAPIRequestFactory = leadsAPIRequestFactory;
//# sourceMappingURL=lead.js.map